module.exports = __webpack_public_path__ + "static/media/img1-1.0cdc318e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/nutricheck_suelo/P/img1-1.png
// module id = 1240
// module chunks = 3